import { Card, Modal } from '@mui/material';
import { lazy, Suspense } from 'react';
import { useProjectVoter } from 'src/hooks/query/voterSearch';
import VoterProfileSkeleton from './VoterProfileSkeleton';

// The modal shell is cheap and the profile is not: it reaches the shared form components, the
// phone-number libraries and mapbox-gl. This modal is reachable from the header's notification
// feed, so an eager import would put all of that in front of every page. Waiting for the chunk
// looks the same as waiting for the voter, because both show the skeleton.
const VoterProfile = lazy(() => import('./VoterProfile'));

type Props = {
  open: boolean;
  onClose: () => void;
  voterId: string;
  projectId: string;
};

export default function VoterProfileModal({ open, onClose, voterId, projectId }: Props) {
  const { data: voter, isLoading } = useProjectVoter(projectId, voterId, {
    enabled: open && !!voterId && !!projectId,
  });

  return (
    <Modal open={open} onClose={onClose}>
      <Card
        sx={{
          width: 700,
          maxWidth: '95vw',
          maxHeight: '90vh',
          overflow: 'auto',
          position: 'absolute',
          left: '50%',
          top: '10%',
          transform: 'translate(-50%, 0)',
          borderRadius: 2,
          padding: 3,
        }}
      >
        {isLoading ? (
          <VoterProfileSkeleton />
        ) : voter ? (
          <Suspense fallback={<VoterProfileSkeleton />}>
            <VoterProfile voter={voter} onClose={onClose} />
          </Suspense>
        ) : null}
      </Card>
    </Modal>
  );
}
